import * as React from 'react';
import {useFormContext} from 'react-hook-form';

const FormConditionCheck = ({name,value,children,}) => {

    const {watch} = useFormContext();
    const watchedValue = watch(name);

	const compareValues = (Array.isArray(value) === false) ? [value] : value;

    return (
        <>
        {(compareValues.includes(watchedValue)) && <>{children}</>}
        </>
    );
};
export default FormConditionCheck;
